import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import ErrorBoundary from './components/feature/ErrorBoundary';
import { ToastProvider } from './components/feature/ToastContainer';
import { TooltipProvider } from './components/base/Tooltip';
import { AuthProvider } from './context/AuthContext';
import './i18n';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ErrorBoundary>
        <AuthProvider>
          <TooltipProvider>
            <ToastProvider>
              <div className="App">
                <AppRoutes />
              </div>
            </ToastProvider>
          </TooltipProvider>
        </AuthProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
